import React from 'react';
import { Group, Rect } from 'react-konva';

import { SOON_MINUTES } from '../lib';

const CanvasTableWarningBar = ({
  minutesLeft,
  container,
  colors,
  // isMobile = false,
}: {
  minutesLeft?: number;
  container: {
    width: number;
    height: number;
    offsetY?: number;
    borderWidth: number;
    borderRadius: number;
  };
  colors: GM.ReservesSchemas.TableStateColorSet;
  // isMobile?: boolean;
}) => {
  if (minutesLeft === undefined || minutesLeft === 0 || minutesLeft > SOON_MINUTES) {
    return null;
  }

  const { width, height, borderWidth, borderRadius } = container;
  const offsetY = container.offsetY ?? 0;
  const barWidth = width * ((SOON_MINUTES - minutesLeft) / SOON_MINUTES);
  // Увеличиваем толщину маркера на мобильных для лучшей видимости
  // const effectiveBorderWidth = isMobile ? Math.max(borderWidth, 2) : borderWidth;
  const effectiveBorderWidth = borderWidth;

  return (
    <Group
      clipX={-effectiveBorderWidth}
      clipY={offsetY}
      clipWidth={barWidth + effectiveBorderWidth * 2}
      clipHeight={height - offsetY + effectiveBorderWidth * 2}
    >
      <Rect
        width={width}
        height={height}
        fill={colors.timeBar.bg}
        stroke={colors.timeBar.border}
        strokeWidth={effectiveBorderWidth}
        cornerRadius={borderRadius}
      />
    </Group>
  );
};

export default CanvasTableWarningBar;
